<template>
  <v-card outlined rounded="lg" class="pa-4" elevation="0">
    <v-row class="ma-0" v-if="!isResult">
      <v-col class="text-center" cols="12">
        <span>{{ $t('Período') }}</span>
        <div class="d-flex justify-center align-center mt-3">
          <v-menu
            ref="startDateMenu"
            :close-on-content-click="false"
            :return-value.sync="startDate"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :disabled="isResult"
                depressed
                append-icon="mdi-calendar"
                class="primary-button"
                style="text-transform: none"
                readonly
                v-bind="attrs"
                v-on="on"
              >
                {{ `${formatMonth(startDate)}` }}
              </v-btn>
            </template>
            <v-date-picker
              v-model="startDate"
              type="month"
              locale="pt-br"
              no-title
              scrollable
              @change="
                $refs.startDateMenu.save(startDate),
                  (filterProp.data = null),
                  list()
              "
            >
            </v-date-picker>
          </v-menu>

          <span class="mx-2">{{ $t('Até') }}</span>

          <v-menu
            ref="endDateMenu"
            :close-on-content-click="false"
            :return-value.sync="endDate"
            transition="scale-transition"
            @change=";(filterProp.data = null), list()"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :disabled="isResult"
                depressed
                append-icon="mdi-calendar"
                class="primary-button"
                style="text-transform: none"
                readonly
                v-bind="attrs"
                v-on="on"
              >
                {{ `${formatMonth(endDate)}` }}
              </v-btn>
            </template>
            <v-date-picker
              v-model="endDate"
              type="month"
              locale="pt-br"
              no-title
              scrollable
              @change="
                $refs.endDateMenu.save(endDate),
                  (filterProp.data = null),
                  list()
              "
            >
            </v-date-picker>
          </v-menu>
        </div>
      </v-col>

      <v-col cols="12">
        <v-divider class="my-4"></v-divider>
      </v-col>
    </v-row>

    <v-alert
      type="warning"
      class="my-3 pa-1 text-center"
      v-if="adhesionCalleds.length == 0"
    >
      {{ $t('Nenhum dado encontrado') }}
    </v-alert>

    <div v-else>
      <v-row class="ma-0" justify="center">
        <v-col cols="12" sm="5">
          <div class="d-flex justify-center">
            <strong>Total: {{ total }}</strong>
            <HorizontalBarChart
              :key="chartKey"
              :chart-data="adhesionChartData"
              :options="options"
              style="min-height: 200px"
            />
          </div>
        </v-col>

        <v-col cols="12" sm="5">
          <v-chart autoresize class="chart" :option="optionsGauge" />
        </v-col>

        <v-col cols="12">
          <v-data-table
            :loading="loading"
            :headers="header"
            :items="adhesionCalleds"
            class="main-table my-2"
            :hide-default-footer="!filterProp.data"
            hide-default-header
            :header-props="headerProps"
            :items-per-page="7"
            :mobile-breakpoint="0"
          >
            <template #header="{ props, on }">
              <thead>
                <tr>
                  <th
                    class="text-center"
                    v-for="header in props.headers"
                    :key="header.value"
                  >
                    <v-simple-checkbox
                      v-if="header.value === 'data-table-select'"
                      v-model="props.everyItem"
                      :indeterminate="props.someItems && !props.everyItem"
                      color="purple"
                      @input="on['toggle-select-all']"
                    ></v-simple-checkbox>

                    <div>
                      <v-hover v-slot="{ hover }">
                        <div>
                          <span>{{ $t(header.text) }}</span>
                          <v-icon
                            v-if="
                              hover &&
                              header.value != 'data-table-select' &&
                              header.value != 'actions'
                            "
                            color="white"
                            class="mx-2"
                            @click="on.sort(header.value)"
                          >
                            {{
                              props.options.sortBy.includes(header.value)
                                ? `mdi-chevron-down`
                                : `mdi-chevron-up`
                            }}
                          </v-icon>
                        </div>
                      </v-hover>
                    </div>
                  </th>
                </tr>
              </thead>
            </template>

            <template v-slot:[`item.calleds`]="{ item }">
              {{ item.calleds }}
            </template>

            <template v-slot:[`item.others`]="{ item }">
              {{ item.others }}
            </template>

            <template v-slot:[`item.percent`]="{ item }">
              {{ item.percent }} %
            </template>
          </v-data-table>
          <div class="pagination" v-if="!filterProp.data">
            <div class="item-pagination block-two">
              <v-pagination
                class="pagination-item"
                v-model="page"
                :length="totalPages"
                :total-visible="3"
              ></v-pagination>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>

    <v-row class="ma-0">
      <v-col cols="12" v-if="isResult">
        <strong>Análise crítica</strong>
        <p v-html="review"></p>
      </v-col>
      <v-col cols="12" v-else>
        <tiptap-vuetify
          v-model="filter.review"
          :extensions="extensions"
          :label="$t('Análise crítica')"
          :placeholder="
            $t('Digite sua análise crítica para o indicador abaixo')
          "
          :card-props="{ flat: true, outlined: true, rounded: true }"
          class="primary-input"
          outlined
          dense
          hide-details="auto"
        ></tiptap-vuetify>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import HorizontalBarChart from '../../../../charts/horizontalBarChart'
import ApiService from '../../../../../../../../services/ApiService'
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { GaugeChart } from 'echarts/charts'
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
} from 'echarts/components'
import VChart, { THEME_KEY } from 'vue-echarts'
import moment from 'moment'
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from 'tiptap-vuetify'

use([
  CanvasRenderer,
  GaugeChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
])

export default {
  props: {
    filterProp: Object,
    institution: Object,
    unidades: Array,
    isResult: { type: Boolean, default: false },
    review: String,
  },

  components: {
    HorizontalBarChart,
    VChart,
    TiptapVuetify,
  },

  provide: {
    [THEME_KEY]: 'light',
  },

  data() {
    return {
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
      filter: {
        page: 1,
        pageSize: 7,
        institutionId: null,
        unidadeIds: [],
        startDate: null,
        endDate: null,
        review: '',
      },
      apiService: new ApiService(),
      loading: false,
      showChart: true,
      adhesionCalleds: [],
      page: 1,
      exampleValue: 50,
      totalPages: 1,
      pageSize: 7,
      val: 5,
      percent: 0,
      options: {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          labels: {
            usePointStyle: true,
          },
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
      optionsGauge: {
        series: [
          {
            type: 'gauge',
            axisLine: {
              lineStyle: {
                width: 10,
                color: [
                  [0.3, '#ED8990'],
                  [0.7, '#FDB578'],
                  [1, '#BCD504'],
                ],
              },
            },
            pointer: {
              itemStyle: {
                color: 'auto',
              },
            },
            axisTick: {
              distance: -20,
              length: 5,
              lineStyle: {
                color: '#fff',
                width: 1,
              },
            },
            splitLine: {
              distance: -20,
              length: 20,
              lineStyle: {
                color: '#fff',
                width: 3,
              },
            },
            axisLabel: {
              color: 'auto',
              distance: 15,
              fontSize: 10,
            },
            detail: {
              valueAnimation: true,
              formatter: '{value} %',
              color: 'auto',
              fontSize: 10,
            },
            data: [
              {
                value: 0,
              },
            ],
            legend: {
              labels: {
                usePointStyle: true,
              },
            },
          },
        ],
      },
      adhesionChartData: {},
      chartKey: false,
      calleds: [],
      calledsOthers: [],
      labels: [],
      headerProps: {
        sortByText: 'Ordenar por',
      },
      header: [
        {
          text: '',
          align: 'center',
          value: '',
        },
        {
          text: 'Corretivas Abertas Por Módulo de Chamados',
          align: 'center',
          value: 'calleds',
        },
        {
          text: 'Corretivas Abertas Por Outros Canais',
          align: 'center',
          value: 'others',
        },
        {
          text: '% O.S. Corretivas Abertas Via Chamados',
          align: 'center',
          value: 'percent',
        },
      ],
      total: 0,
      startDate: '',
      endDate: '',
    }
  },

  created() {
    this.filter.institutionId = this.institution.id
    this.filter.unidadeIds = this.unidades

    this.startDate = moment()
      .add(-1, 'month')
      .clone()
      .startOf('month')
      .format('YYYY-MM-DD')

    this.endDate = moment()
      .add(-1, 'month')
      .clone()
      .endOf('month')
      .format('YYYY-MM-DD')

    if (this.filterProp) {
      this.filter = this.filterProp
      this.startDate = moment(this.filter.startDate)
        .clone()
        .startOf('month')
        .format('YYYY-MM-DD')

      this.endDate = moment(this.filter.endDate)
        .clone()
        .endOf('month')
        .format('YYYY-MM-DD')
    }

    this.list()
  },

  methods: {
    setDates() {
      this.filter.startDate = moment(this.startDate)
        .clone()
        .startOf('month')
        .format('YYYY-MM-DD')

      this.filter.endDate = moment(this.endDate)
        .clone()
        .endOf('month')
        .format('YYYY-MM-DD')
    },

    setInfos() {
      const model = {
        chart: '4.3 - Adesão ao módulo de chamados',
        ...this.filter,
        data: null,
      }
      this.$emit('setInfos', model)
    },

    formatMonth(date) {
      return moment(date).locale(this.$i18n.locale).format('MMMM/YYYY')
    },

    async list() {
      if (this.filterProp.data) {
        const response = JSON.parse(this.filterProp.data)
        this.adhesionCalleds = []
        this.calleds = []
        this.calledsOthers = []

        this.total =
          response.content.abertasChamado + response.content.abertasOutros

        this.calleds.push(response.content.abertasChamado)
        this.calledsOthers.push(response.content.abertasOutros)
        this.percent = response.content.porcentagem

        this.adhesionCalleds.push({
          calleds: response.content.abertasChamado,
          others: response.content.abertasOutros,
          percent: response.content.porcentagem,
        })

        console.log(this.adhesionCalleds)
        this.fillAdhesionCalledChartData()
        return
      }

      this.setDates()
      this.filter.institutionId = this.institution.id
      this.filter.pageSize = 7
      this.filter.unidadeIds = this.unidades
      await this.apiService
        .post('reports/adhesionCalled', this.filter)
        .then((response) => {
          this.adhesionCalleds = []
          this.calleds = []
          this.calledsOthers = []

          this.total =
            response.content.abertasChamado + response.content.abertasOutros
          // if (response.content.objects) {
          //   this.showChart = response.content.objects.length > 0;
          // }

          this.calleds.push(response.content.abertasChamado)
          this.calledsOthers.push(response.content.abertasOutros)
          this.percent = response.content.porcentagem

          this.adhesionCalleds.push({
            calleds: response.content.abertasChamado,
            others: response.content.abertasOutros,
            percent: response.content.porcentagem,
          })
        })
        .catch((err) => {})

      this.fillAdhesionCalledChartData()
    },

    fillAdhesionCalledChartData() {
      this.adhesionChartData = {
        labels: [''],
        datasets: [
          {
            label: 'Via Chamados',
            data: this.calleds,
            backgroundColor: '#87AFA6',
          },
          {
            label: 'Outros Canais',
            data: this.calledsOthers,
            backgroundColor: '#BAB3D3',
          },
        ],
      }

      setTimeout(() => {
        this.chartKey = !this.chartKey
      }, 500)
    },
  },

  watch: {
    page() {
      this.filter.page = this.page
      this.list()
    },
    percent(nv, ov) {
      this.optionsGauge.series[0].data[0].value = nv
    },
    filter: {
      deep: true,
      handler() {
        this.setInfos()
      },
    },
  },
}
</script>
